{
  "lastUpdatedAt": "2026-07-29T11:09:58.956Z",
  "lastFetchAttemptAt": "2026-07-29T11:09:58.956Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}